import React, { useState } from "react"
import styles from './primas.module.css'
import arrowPrima from '../../../../img/arrowCollapse.jpg'
import * as Funciones from '../../../../utils/funciones'
import * as Constantes from "../../../../utils/constantes";
import TerminosCondiciones from "../terminos-condiciones";

const Primas = ({ data = [], retorno = {}, tipoCambio }) => {
    const [collapsedPrima, setCollapsedPrima] = useState(false)
    let retornosDolares = retorno !== null ? retorno.filter(retornoAux => retornoAux.simboloMoneda === '$') : []
    let retornosSoles = retorno !== null ? retorno.filter(retornoAux => retornoAux.simboloMoneda === 'S/') : []

    const tooglePrima = () => {
        setCollapsedPrima(!collapsedPrima)
    }

    const getValuePrima = () => {
        // Array de productos
        const products = data

        const response = {
            dolares: [],
            soles: []
        }

        if (products.length === 0) return response

        // Array filtrado por tipo de moneda
        const arrDolares = products.filter((e) => e.moneda.codigo === 1)
        const arrSoles = products.filter((e) => e.moneda.codigo === 2)

        // Valido si las frecuencias de pago son las mismas en el array de tipos de moneda
        const allProductsFrecuenciaDollarAreSame = arrDolares.every((e) => e.frecuenciaPago.codigo === arrDolares[0].frecuenciaPago.codigo)
        const allProductFrecuenciaSolesAreSame = arrSoles.every((e) => e.frecuenciaPago.codigo === arrSoles[0].frecuenciaPago.codigo)

        // Pregunto si no son las mismas frecuencias de pago entonces recorro y filtro
        if (allProductsFrecuenciaDollarAreSame === false) {
            response.dolares = arrDolares.reduce((a, b) => {
                const i = a.findIndex((x) => x.codigo === b.frecuenciaPago.codigo)
                return i === -1 ? a.push({
                    codigo: b.frecuenciaPago.codigo,
                    descripcion: b.frecuenciaPago.descripcion,
                    value: b.primaTotal
                }) : a[i].value += b.primaTotal, a;
            }, [])
        } else {
            if (arrDolares.length > 0) {
                response.dolares = [{
                    codigo: arrDolares[0].frecuenciaPago.codigo,
                    descripcion: arrDolares[0].frecuenciaPago.descripcion,
                    value: arrDolares.reduce((acc, curr) => acc + curr.primaTotal, 0)
                }]
            }
        }

        // Pregunto si no son las mismas frecuencias de pago entonces recorro y filtro
        if (allProductFrecuenciaSolesAreSame === false) {
            response.soles = arrSoles.reduce((a, b) => {
                const i = a.findIndex((x) => x.codigo === b.frecuenciaPago.codigo)
                return i === -1 ? a.push({
                    codigo: b.frecuenciaPago.codigo,
                    descripcion: b.frecuenciaPago.descripcion,
                    value: b.primaTotal
                }) : a[i].value += b.primaTotal, a;
            }, [])
        } else {
            if (arrSoles.length > 0) {
                response.soles = [{
                    codigo: arrSoles[0].frecuenciaPago.codigo,
                    descripcion: arrSoles[0].frecuenciaPago.descripcion,
                    value: arrSoles.reduce((acc, curr) => acc + curr.primaTotal, 0)
                }]
            }
        }

        return response
    }

    const getCountPrima = () => {
        let counter = 0
        const obj = getValuePrima()
        counter = obj.dolares.length + obj.soles.length
        return counter
    }

    const renderPrimas = () => {
        const arrPrimas = getValuePrima()
        const countProducts = getCountPrima()
        if (countProducts === 0) return
        // Si solo tiene 1 frecuencia de pago x moneda y es 1 moneda
        if (countProducts === 1) {
            const arrNotEmpty = arrPrimas.dolares.length > 0 ? arrPrimas.dolares : arrPrimas.soles
            return (
                <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`}>
                    <div className={styles.primaCol}>
                        <div className={styles.primaPrice}>
                            {arrPrimas.dolares.length > 0 ? '$' : 'S/'} {arrNotEmpty[0].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        </div>
                        <div className={styles.primaMonth}>
                            {arrNotEmpty[0].descripcion}
                        </div>
                    </div>
                </div>
            )
        }
        // Si tiene 2 frecuencia de pago x moneda y es soles o dolares
        if (countProducts === 2 && (arrPrimas.dolares.length === 2 || arrPrimas.soles.length === 2)) {
            const typeArrMoneda = arrPrimas.dolares.length === 2 ? arrPrimas.dolares : arrPrimas.soles
            const typeMoneda = arrPrimas.dolares.length === 2 ? '$' : 'S/'
            return (
                <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`}>
                    <div className={styles.primaCol}>
                        <div className={styles.primaPrice}>
                            {typeMoneda} {typeArrMoneda[0].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        </div>
                        <div className={styles.primaMonth}>
                            {typeArrMoneda[0].descripcion}
                        </div>
                    </div>
                    <div className={styles.primaY}>
                        y
                    </div>
                    <div className={styles.primaCol}>
                        <div className={styles.primaPrice}>
                            {typeMoneda} {typeArrMoneda[1].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        </div>
                        <div className={styles.primaMonth}>
                            {typeArrMoneda[1].descripcion}
                        </div>
                    </div>
                </div>
            )
        }
        // Si tiene 3 frecuencia de pago x moneda y es soles o dolares
        if (countProducts === 3 && (arrPrimas.dolares.length === 3 || arrPrimas.soles.length === 3)) {
            const typeArrMoneda = arrPrimas.dolares.length === 3 ? arrPrimas.dolares : arrPrimas.soles
            const typeMoneda = arrPrimas.dolares.length === 3 ? '$' : 'S/'
            return (
                <React.Fragment>
                    <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`} style={{ marginBottom: '15px' }}>
                        <div className={styles.primaCol}>
                            <div className={styles.primaPrice}>
                                {typeMoneda} {typeArrMoneda[0].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                            </div>
                            <div className={styles.primaMonth}>
                                {typeArrMoneda[0].descripcion}
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`}>
                        <div className={styles.primaCol}>
                            <div className={styles.primaPrice}>
                                {typeMoneda} {typeArrMoneda[1].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                            </div>
                            <div className={styles.primaMonth}>
                                {typeArrMoneda[1].descripcion}
                            </div>
                        </div>
                        <div className={styles.primaY}>
                            y
                        </div>
                        <div className={styles.primaCol}>
                            <div className={styles.primaPrice}>
                                {typeMoneda} {typeArrMoneda[2].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                            </div>
                            <div className={styles.primaMonth}>
                                {typeArrMoneda[2].descripcion}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
        // Si solo tiene 1 frecuencia de pago x moneda y son 2 monedas distintas
        if (countProducts === 2 && arrPrimas.dolares.length === 1 && arrPrimas.soles.length === 1) {
            return (
                <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`}>
                    <div className={styles.primaCol}>
                        <div className={styles.primaPrice}>
                            $ {arrPrimas.dolares[0].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        </div>
                        <div className={styles.primaMonth}>
                            {arrPrimas.dolares[0].descripcion}
                        </div>
                    </div>
                    <div className={styles.primaY}>
                        y
                    </div>
                    <div className={styles.primaCol}>
                        <div className={styles.primaPrice}>
                            S/ {arrPrimas.soles[0].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        </div>
                        <div className={styles.primaMonth}>
                            {arrPrimas.soles[0].descripcion}
                        </div>
                    </div>
                </div>
            )
        }
        // Si tiene 2 frecuencia de pago en 1 moneda y la otra tiene 1 frecuencia de pago
        if (countProducts === 3 && (arrPrimas.dolares.length === 2 || arrPrimas.soles.length === 2)) {
            const doubleFrecuenciaUSD = arrPrimas.dolares.length === 2
            if (doubleFrecuenciaUSD) {
                return (
                    <React.Fragment>
                        <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`} style={{ marginBottom: '15px' }}>
                            <div className={styles.primaCol}>
                                <div className={styles.primaPrice}>
                                    S/ {arrPrimas.soles[0].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                </div>
                                <div className={styles.primaMonth}>
                                    {arrPrimas.soles[0].descripcion}
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`}>
                            <div className={styles.primaCol}>
                                <div className={styles.primaPrice}>
                                    $ {arrPrimas.dolares[0].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                </div>
                                <div className={styles.primaMonth}>
                                    {arrPrimas.dolares[0].descripcion}
                                </div>
                            </div>
                            <div className={styles.primaY}>
                                y
                            </div>
                            <div className={styles.primaCol}>
                                <div className={styles.primaPrice}>
                                    $ {arrPrimas.dolares[1].value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                </div>
                                <div className={styles.primaMonth}>
                                    {arrPrimas.dolares[1].descripcion}
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            } else {
                return (
                    <React.Fragment>
                        <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`}>
                            <div className={styles.primaCol}>
                                <div className={styles.primaPrice}>
                                    $ {arrPrimas.dolares[0].value}
                                </div>
                                <div className={styles.primaMonth}>
                                    {arrPrimas.dolares[0].descripcion}
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.primaRow} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.primaRowDoble : null}`}>
                            <div className={styles.primaCol}>
                                <div className={styles.primaPrice}>
                                    S/ {arrPrimas.soles[0].value}
                                </div>
                                <div className={styles.primaMonth}>
                                    {arrPrimas.soles[0].descripcion}
                                </div>
                            </div>
                            <div className={styles.primaY}>
                                y
                            </div>
                            <div className={styles.primaCol}>
                                <div className={styles.primaPrice}>
                                    S/ {arrPrimas.soles[1].value}
                                </div>
                                <div className={styles.primaMonth}>
                                    {arrPrimas.soles[1].descripcion}
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            }
        }

        return ''
    }

    const renderRetornos = () => {
        return (
            <React.Fragment>
                {retornosDolares.length > 0
                    ? <div className={styles.retornos_dolares}>
                        {retornosDolares.map((retornoDolares, indexDolares) => (
                            <div key={'li_dolares_' + indexDolares} className={styles['li_retorno_' + retornosDolares.length]}>
                                <div className={styles.primaRetorno}>
                                    {retornoDolares.simboloMoneda} {retornoDolares ? Funciones.mostrarFormatoMoneda(Math.round(retornoDolares.monto * 100) / 100) : null}
                                </div>
                                <div className={styles.primaMonth}>
                                    {retornoDolares.caption}
                                </div>
                            </div>
                        ))}
                    </div>
                    : null
                }
                {retornosSoles.length > 0
                    ? <div className={styles.retornos_soles}>
                        {retornosSoles.map((retornoSoles, indexSoles) => (
                            <div key={'li_soles_' + indexSoles} className={styles['li_retorno_' + retornosSoles.length]}>
                                <div className={styles.primaRetorno}>
                                    {retornoSoles.simboloMoneda} {retornoSoles ? Funciones.mostrarFormatoMoneda(Math.round(retornoSoles.monto * 100) / 100) : null}
                                </div>
                                <div className={styles.primaMonth}>
                                    {retornoSoles.caption}
                                </div>
                            </div>
                        ))}
                    </div>
                    : null
                }
            </React.Fragment>
        )
    }

    const getTerminosCondiciones = () => {
        return Constantes.TERMINOS_GENERAL.filter(termino => {
            if (termino.id === 2 && (retorno === null || retorno.length === 0)) {
                return false
            }
            return true
        })

    }

    const getAclaraciones = () => {
        return Constantes.ACLARACIONES_1.map(aclaracion => {
            aclaracion.descripcion = Funciones.reemplazarUrlServicio(aclaracion.descripcion,
                [{ campo: 'tipoCambio', valor: tipoCambio }])
            return aclaracion
        })
    }

    return (
        <div className={styles.margen}>
            {!collapsedPrima ?
                <div className={styles.expandir}>
                    <h2 onClick={tooglePrima}>Expandir</h2>
                    <img
                        src={arrowPrima}
                        alt=""
                        onClick={tooglePrima}
                    />
                </div>
                : null
            }

            {collapsedPrima ?
                <React.Fragment>
                    <div className={styles.primas}>
                        <div className={`${styles.card} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.cardDoble : null}`}>
                            <p>Por tu plan de protección pagarás en total una prima de<sup>(1)</sup>:</p>
                            {renderPrimas()}
                        </div>
                        {retorno.length > 0 ?
                            <div className={`${styles.card} ${(retornosDolares.length * retornosSoles.length) > 0 ? styles.cardDoble : null}`}>
                                <p>Si mantiene la póliza vigente en el tiempo, podrías obtener<sup>(2)</sup>:</p>
                                <div className={styles.primaRow2}>
                                    {renderRetornos()}
                                </div>
                            </div>
                            : null
                        }
                    </div>
                    <TerminosCondiciones
                        terminosCondiciones={getTerminosCondiciones()}
                        aclaraciones={getAclaraciones()}
                        fixedText="Comisión de Comercialización del canal de Corredores de Vida Individual  y Accidentes Personales desde 1%."
                    />

                </React.Fragment>
                : null
            }

            {collapsedPrima ?
                <div className={styles.expandir}>
                    <h2 onClick={tooglePrima}>Reducir</h2>
                    <img
                        style={{ transform: 'rotate(180deg)' }}
                        src={arrowPrima}
                        alt=""
                        onClick={tooglePrima}
                    />
                </div>
                : null
            }
        </div>
    )
}

export default Primas